// extracted by mini-css-extract-plugin
export default {"addToCart":"AddedToCartBig_addToCart__R18e9","add":"AddedToCartBig_add__aU7se"};